<template>
  <quill-editor :options="editorOption" v-model="content" @input="onEditorInput"></quill-editor>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      content: this.value,  // Lier l'état interne avec v-model
      editorOption: {
        theme: 'snow',
        placeholder: '....',
        modules: {
          clipboard: {
            allowed: {
              tags: ['a', 'b', 'strong', 'u', 's', 'i', 'p', 'br', 'ul', 'ol', 'li', 'span'],
              attributes: ['href', 'rel', 'target', 'class']
            },
            keepSelection: true,
            substituteBlockElements: true,
            magicPasteLinks: true,
            hooks: {
              uponSanitizeElement(node, data, config) {
                console.log(node);
              },
            },
          },
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{'list': 'ordered'}, {'list': 'bullet'}],
            [{'header': [1, 2, 3, 4, 5, 6, false]}],
            [{'font': []}],
            [{'align': []}],
            ['link'],
            ['clean']
          ]
        }
      }
    }
  },
  watch: {
    value(newValue) {
      // Synchronise l'éditeur quand la valeur change depuis le parent
      this.content = newValue;
    }
  },
  methods: {
    onEditorInput(value) {
      this.$emit('input', value);  // Émet la mise à jour vers le parent
    }
  }
}
</script>
